import type { RouteLocationRaw } from 'vue-router'

interface NavigateToOptions {
  replace?: boolean
  redirectCode?: number
  external?: boolean
  open?: OpenOptions
}

type OpenOptions = {
  target: string
}

export const useCustomNavigation = () => {
  const cmdState = useKeyModifier('Meta')
  const ctrlState = useKeyModifier('Control')
  const ctrlHeld = computed(() => cmdState.value || ctrlState.value)

  const customNavigateTo = (to?: string | RouteLocationRaw | null, options?: NavigateToOptions) => {
    if (ctrlHeld.value) {
      return navigateTo(to, {
        ...options,
        open: { target: '_blank' },
      })
    }

    return navigateTo(to, options)
  }

  return {
    customNavigateTo,
  }
}
